module.exports = __webpack_public_path__ + "static/media/selectedleftnew.ba325bed.svg";